/**
 * Copy text to the clipboard, falling back to a hidden textarea where the
 * async Clipboard API is unavailable, which is the case on any page not served
 * over a secure context.
 */ export const copyToClipboard = (value)=>{
    if (navigator.clipboard) {
        navigator.clipboard.writeText(value).catch(()=>{});
        return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

//# sourceMappingURL=copyToClipboard.js.map